import styled, { css } from 'styled-components/macro';
import { getLuminance } from 'polished';

export const Paragraph = styled.p`
  font-style: normal;
  line-height: 140%;
  font-weight: ${({ theme, bold }) => (bold
    ? theme.fonts.secondary.weight.bold
    : theme.fonts.secondary.weight.normal)};
  font-family: ${({ theme }) => theme.fonts.secondary.family}, sans-serif;
  font-size: ${({ theme, fontSize }) => (
    (theme.fonts.secondary.scaling || 1) * (fontSize || 15))}px;
  user-select: text !important;
  opacity: ${({ opacity }) => opacity || 1};

  color: ${({ theme, color, contrastAgainst }) => (color
    ? (theme.colors[color] || color)
    : contrastAgainst
      ? getLuminance(theme.colors[contrastAgainst] || contrastAgainst) > 0.5
        ? theme.colors.contrastDark
        : theme.colors.contrastLight
      : theme.colors.body
  )};
`;

export const Title = styled(Paragraph)`
  line-height: 120%;
  font-weight: ${({ theme, bold }) => (bold
    ? theme.fonts.primary.weight.bold
    : theme.fonts.primary.weight.normal)};
  font-family: ${({ theme }) => theme.fonts.primary.family}, sans-serif;
  font-size: ${({ theme, fontSize }) => (
    (theme.fonts.primary.scaling || 1) * (fontSize || 40))}px;
  color: ${({ theme, color }) => (color
    ? theme.colors[color]
    : theme.colors.title
  )};
`;

export const Label = styled(Paragraph)`
  font-size: ${({ theme, fontSize }) => (
    (theme.fonts.secondary.scaling || 1) * (fontSize || 14))}px;
  letter-spacing: ${({ theme }) => (theme.lang.dir === 'ltr' ? 3 : 0)}px;
  text-transform: uppercase;
`;

export const Link = styled(Paragraph)`
  font-size: ${({ theme, fontSize }) => (
    (theme.fonts.secondary.scaling || 1) * (fontSize || 14))}px;
`;

export const Copyright = styled(Paragraph)`
  font-size: ${({ theme, fontSize }) => (
    (theme.fonts.secondary.scaling || 1) * (fontSize || 12))}px;

  opacity: 0.5;
  transition: opacity 300ms;
  ${({ hoverable }) => hoverable && css`
    &:hover {
      opacity: 0.8;
    }
  `}
`;

Title.defaultProps = {
  as: 'h1',
};
